module.exports={render:function (){
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": 'imbee-' + _vm.callToAction.animation
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.opened && _vm.show),
      expression: "!opened && show"
    }],
    staticClass: "bubble-call-to-action",
    style: (( _obj = {
      bottom: _vm.callToAction.verticalPadding
    }, _obj[_vm.alignment] = _vm.callToAction.horizontalPadding, _obj.alignItems = _vm.alignment == 'left' ? 'flex-start' : 'flex-end', _obj ))
  }, [_c('div', {
    staticClass: "call-to-action-close"
  }, [_c('div', {
    staticClass: "close-cta",
    staticStyle: {
      "background": "rgba(0, 0, 0, 0.4)"
    },
    attrs: {
      "id": "close-cta"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeCTA.apply(null, arguments)
      }
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z",
      "fill": "#ffffff"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "call-to-action-content-wrapper",
    style: ({
      backgroundColor: _vm.callToAction.backgroundColor,
      color: _vm.callToAction.fontColor,
      fontSize: _vm.callToAction.fontSize,
      fontFamily: _vm.callToAction.fontFamily,
      fontWeight: _vm.callToAction.fontWeight,
    }),
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.open.apply(null, arguments)
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.callToAction.text) + "\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9a7db92a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CallToAction.vue
// module id = 221
// module chunks = 0 1